import type { schemaType as contactPageSchematype } from '~~/shared/api/strapi/contact-page/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-content-figures.vue'

export const useToSContentFigures = () => {
  const fromStrapiContactPage = (
    data: contactPageSchematype,
  ): propsInterface => {
    let items: propsInterface['items'] = []

    items = data.attributes.blocks.map(item => {
      return {
        title: item.title,
        content: item.content,
        desktopImageRight: item.desktopImageRight,
        image: item.image.data.attributes.url,
        ...(item.cta && {
          cta: {
            text: item.cta.text,
            url: item.cta.url,
          },
        }),
      }
    })

    return { items }
  }

  return { fromStrapiContactPage }
}
